import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Chip,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";
import { ModeDefinition } from "../../mode/modes";

interface ModeCardProps {
  modeKey: string;
  mode: ModeDefinition;
  onSelect: () => void;
}

export default function ModeCard({ mode, onSelect }: ModeCardProps) {
  const comingSoon = mode.components.Form === undefined;
  const background =
    mode.color1 && mode.color2
      ? `linear-gradient(135deg, ${mode.color1}, ${mode.color2})`
      : mode.color1
        ? mode.color1
        : grey[600];

  return (
    <Card sx={{ height: "100%", width: "100%", position: "relative" }}>
      {comingSoon && (
        <Chip
          label="Coming Soon"
          size="small"
          sx={{
            position: "absolute",
            zIndex: 1,
            top: 12,
            right: 12,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            color: grey[700],
            fontWeight: 600,
            fontSize: "0.7rem",
          }}
        />
      )}
      <CardActionArea
        onClick={comingSoon ? undefined : onSelect}
        disabled={comingSoon}
        sx={{
          height: "100%",
          background,
          color: "#FFFFFF",
          display: "flex",
          alignItems: "stretch",
          cursor: comingSoon ? "default" : "pointer",
          filter: comingSoon ? "brightness(50%) grayscale(50%)" : undefined,
        }}
      >
        <CardContent
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography variant="h6">
            {mode.icon && (
              <mode.icon
                style={{ verticalAlign: "text-bottom", marginRight: 8 }}
              />
            )}
            {mode.label}
          </Typography>
          <Typography variant="body2">{mode.description}</Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
